import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__clock",
  "use": "general__clock-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"general__clock\">\n  <g fill=\"none\">\n    <circle cx=\"7.5\" cy=\"7.5\" fill=\"var(--color-blue-dark)\" r=\"7\" stroke=\"var(--color-blue-dark)\" />\n    <rect height=\"5.3\" rx=\".5\" stroke=\"var(--color-icons-alt)\" width=\"1\" x=\"6.26\" y=\"3.4\" />\n    <rect height=\"4\" rx=\".5\" stroke=\"var(--color-icons-alt)\" transform=\"rotate(90 8.3 8.45)\" width=\"1\" x=\"8.05\" y=\"6.45\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol